var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.0008C14.253 21.0008 13.5066 20.7128 12.9411 20.1472L4.79105 11.9972C4.62382 11.83 4.62382 11.5466 4.79105 11.3793C4.95829 11.2121 5.24171 11.2121 5.40895 11.3793L13.5589 19.5293C14.3542 20.3246 15.6458 20.3246 16.4411 19.5293L24.5911 11.3793C24.7583 11.2121 25.0417 11.2121 25.2089 11.3793C25.3762 11.5466 25.3762 11.83 25.2089 11.9972L17.0589 20.1472C16.4934 20.7128 15.747 21.0008 15 21.0008Z",
    fill: "#6D77A0",
    stroke: "#6D77A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.3208fff9c7db177482ac396d2f277e74.svg";
export { ForwardRef as ReactComponent };